export const commentLineWidth = 3;

export const commentRadius = 14;

export const commentBboxPadding = 10 + (commentRadius + commentLineWidth);

export const commentExtraSpacing = 20;

export const getCircleBgColor = ({
  isComponentRequest,
  initial,
}: {
  isComponentRequest?: boolean;
  initial: string;
}) => {
  if (initial.match(/[A-D]/)) {
    return isComponentRequest ? 'bg-brand' : '#F27E31';
  } else if (initial.match(/[E-H]/)) {
    return isComponentRequest ? 'bg-red-50' : '#EB5E55';
  } else if (initial.match(/[I-L]/)) {
    return isComponentRequest ? 'bg-green-50' : '#2AC084';
  } else if (initial.match(/[M-P]/)) {
    return isComponentRequest ? 'bg-blue-50' : '#4472BD';
  } else if (initial.match(/[Q-T]/)) {
    return isComponentRequest ? 'bg-yellow-50' : '#B28B00';
  } else {
    return isComponentRequest ? 'bg-black' : '#000000';
  }
};
